<template>
    <div>
        <header>
            <span class="eventAvatar">
                <img class="rounded-circle" :src="authorProfilePicture" alt="..."/>
            </span>
            <h5 class="eventTitle"><a @click="$router.push('/users/' + authorUid)">{{authorFullName}} </a>
                <small><slot name="nextToName"></slot>
                </small>
            </h5>
            <p class="eventTimestamp">
                <timeago :datetime="createdOn |unixToDate" :auto-update="60"></timeago>
            </p>
        </header>

        <slot></slot>

        <footer class="eventFooter">
            <div class="clearfix">
                <ul class="post-links mt-sm pull-left">

                    <li><a href="#">
                        <Likes :object-id="comment.id"></Likes>
                    </a></li>
                    <li><a href="#">Comment</a></li>
                </ul>

                <!--                <span class="thumb thumb-sm pull-right">-->
                <!--                    <a href="#">-->
                <!--                        <img class="rounded-circle" alt="..." src="../../../assets/people/a1.jpg"/>-->
                <!--                    </a>-->
                <!--                </span>-->
                <!--                <span class="thumb thumb-sm pull-right">-->
                <!--                    <a href="#">-->
                <!--                        <img class="rounded-circle" alt="..." src="../../../assets/people/a5.jpg"/>-->
                <!--                    </a>-->
                <!--                </span>-->
                <!--                <span class="thumb thumb-sm pull-right">-->
                <!--                    <a href="#">-->
                <!--                        <img class="rounded-circle" alt="..." src="../../../assets/people/a3.jpg"/>-->
                <!--                    </a>-->
                <!--               </span>-->
            </div>
            <slot name="comments-thread">
                <comments-thread :thread-id="commentThreadId">

                </comments-thread>
            </slot>
        </footer>
    </div>
</template>


<script>
  import CommentsThread from '../../Comments/CommentsThread'

  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  import Vue from 'vue'
  import VueTimeago from 'vue-timeago'
  import Likes from '@/components/Likes/Likes'
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  Vue.use(VueTimeago, {
    name:    'Timeago', // Component name, `Timeago` by default
    locale:  'en', // Default locale
    // We use `date-fns` under the hood
    // So you can use all locales from it
    locales: {
      'zh-CN': require('date-fns/locale/zh_cn'),
      ja:      require('date-fns/locale/ja')
    }
  })

  export default {
    name:       'GenericPostType',
    components: {
      CommentsThread,
      Likes,
    },
    mixins:
                [
                  UIHelpersMixins,
                ],
    props:      {
      'uid':             String,
      'commentThreadId': String,
      'createdOn':       Object
    },
    data ()
    {
      return {
        authorUid:            '',
        authorProfilePicture: '',
        authorFullName:       '',
        comment:              {},
        childs:               [],
        writeComment:         '',
        commentsThreadId:     null,
      }
    },
    mounted ()
    {
      var that = this

      that.$store.dispatch('userProfiles/retreiveProfile', that.uid).then(function (userProfile) {

        that.authorUid            = userProfile.uid
        that.authorProfilePicture = userProfile.profilePicture
        that.authorFullName       = userProfile.fullName

      }).catch(function (err) {
        console.log(err)
      })

    },

    computed: {

      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    methods:  {},
    watch:    {}
  }

</script>

<style src="@/pages/Profile/Profile.scss" lang="scss" scoped/>

<style scoped>
    .eventFooter{
        margin-top: 0px;
    }


</style>
